/* eslint-disable react/jsx-props-no-spreading */
import { Dispatch, SetStateAction } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { Container, Error, Input } from './styles';

// type Dispatcher<S> = Dispatch<SetStateAction<S>>;

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  sizeDisplay?: 'lg' | 'md' | 'sm';
  error?: boolean;
  showIcon: boolean;
  setShowIcon: Dispatch<SetStateAction<boolean>>;
  errorMessage?: string;
}


const StyledInputWithIcon: React.FC<IProps> = ({
  sizeDisplay = 'lg',
  showIcon,
  error = false,
  setShowIcon,
  errorMessage = '',
  ...rest
}) => (
  <Container sizeDisplay={sizeDisplay}>
    <div className='input-icon-container'>
      <Input error={error} {...rest} />
      {showIcon ? (
        <FiEye
          onClick={() => {
            setShowIcon(!showIcon);
          }}
          style={{ cursor: 'pointer', marginRight: '8px' }}
        />
      ) : (
        <FiEyeOff
          onClick={() => {
            setShowIcon(!showIcon);
          }}
          style={{ cursor: 'pointer', marginRight: '8px' }}
        />
      )}
    </div>
    {error && errorMessage !== '' && <Error>{errorMessage}</Error>}
  </Container>
);

export { StyledInputWithIcon };
